import { ExporterPropertyBase, } from "./SDKExporterPropertyBase";
export class ExporterPropertyDefinitionString extends ExporterPropertyBase {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a;
        super(model);
        // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
        // MARK: - Public properties
        this.type = "String";
        this.isMultiline = (_a = model.isMultiline) !== null && _a !== void 0 ? _a : false;
        this.defaultValue = model.default;
    }
}
